<template>
  <div v-if="product">
    <navbar>
      <template #before>
        <router-link to="/" class="btn btn-sm btn-outline-light">
          Back
        </router-link>
      </template>
      <template v-if="product" #title>
        <span class="navbar-brand" v-text="product.local_name"></span>
      </template>
    </navbar>
    <container>
      <div v-if="product" class="mt-3">
        <div class="card shadow-sm mb-3">
          <sds-product :product="product" class="card-body"></sds-product>
          <sds-product-info
            v-if="showInfo"
            :product="product"
            class="card-body"
          ></sds-product-info>
          <div class="card-footer d-flex justify-content-between gap-2">
            <div>
              <button
                class="btn btn-sm btn-outline-secondary"
                @click="showInfo = !showInfo"
              >
                <span v-if="!showInfo">Show Details</span>
                <span v-else>Hide Details</span>
              </button>
            </div>
            <div class="d-flex gap-2">
              <a
                :href="`/api/products/label/${product.id}`"
                target="_blank"
                class="btn btn-outline-primary btn-sm"
              >
                Labels (8.5x11)
              </a>
              <a
                :href="`/api/products/label/${product.id}?page=single`"
                target="_blank"
                class="btn btn-outline-primary btn-sm"
              >
                Label (2x4)
              </a>
            </div>
          </div>
        </div>
        <div v-if="product && product.sds">
          <h3 class="fw-light">Safety Data Sheet</h3>
          <pdf v-if="sdsBlob" :blob="sdsBlob"></pdf>
        </div>
        <div v-if="product && product.eds">
          <h3 class="fw-light">Environmental Data Sheet</h3>
          <pdf v-if="edsBlob" :blob="edsBlob"></pdf>
        </div>
      </div>
    </container>
  </div>
</template>
<script>
import Pdf from "../../components/Pdf.vue";
import SdsProduct from "../../components/SdsProduct.vue";
import SdsProductInfo from "../../components/SdsProductInfo.vue";
export default {
  components: { Pdf, SdsProduct, SdsProductInfo },
  name: "ProductsView",
  data: () => ({
    product: null,
    sdsBlob: null,
    edsBlob: null,
    showInfo: false,
  }),
  methods: {
    getBlob(type) {
      const key = [
        "files",
        type,
        this.product.id,
        this.product[type + "_hash"],
      ].join("-");
      this.$vlf.getItem(key).then((res) => {
        this[type + "Blob"] = res;
      });
    },
  },
  async mounted() {
    this.product = this.$store.getters.products.find(
      (p) => p.id == this.$route.params.id
    );

    if (!this.product) {
      // this.$router.push(`/?to=${this.$route.params.id}`);

      document.title = "Loading... | c3s";

      const { data } = await this.axios.get(
        `/api/products/get/${this.$route.params.id}.json`
      );

      if (data.sds_hash) {
        const sdsName = encodeURIComponent(data.sds.split("/", 2)[1]);
        const sdsKey = `files-sds-${data.id}-${data.sds_hash}`;
        await this.axios({
          url: `/api/products/files/sds/${sdsName}`,
          method: "POST",
          responseType: "blob",
        }).then((res) => {
          this.$vlf.setItem(sdsKey, res.data);
        });
      }
      if (data.eds_hash) {
        const edsName = encodeURIComponent(data.eds.split("/", 2)[1]);
        const edsKey = `files-eds-${data.id}-${data.eds_hash}`;
        await this.axios({
          url: `/api/products/files/eds/${edsName}`,
          method: "POST",
          responseType: "blob",
        }).then((res) => {
          this.$vlf.setItem(edsKey, res.data);
        });
      }
      this.product = data;
    }
    document.title = `${this.product.name} | c3s`;
    this.getBlob("sds");
    this.getBlob("eds");
  },
};
</script>
